$(document).ready(function() {
    let ajaxPathTagReport = "/action/report/tag";
    let ajaxPathGetTagReport = ajaxPathTagReport + '/tag-report';
    let ajaxPathGetTagReportFavoriteListItems = ajaxPathTagReport + '/favorite/list-items';
    let ajaxPathSaveTagReportFavorite = ajaxPathTagReport + '/favorite/save';
    let ajaxPathGetForm = ajaxPathTagReport + '/form/';
    let excelExportURL = "/action/report/excel/tag-report";

    let formWrapper = $('div#tag_report_wrapper');
    let ajaxLockActive = false;

    $(document).on('click', 'div#tag_report_wrapper button#show_tag_report', function () {
        getTagReport();
    });

    $(document).on('click', 'div#tag_report_wrapper a#tag-report-excel-export-button', function () {
        createExcelFile();
        return false;
    });

    $(document).on('click', 'div#tag_report_wrapper div#tag_report_content tr.tr_product_group_tag td, ' +
        'div#tag_report_wrapper div#tag_report_content tr.tr_product_tag td', function () {
        // Toggle this tags product details
        let tagId = $(this).closest('tr').attr('tag_id');
        $('tr[parent_tag_id="' + tagId + '"]').each(function() {
            $(this).toggle();
        });
    });

    $(document).on('click', 'div#tag_report_wrapper div#save_tag_report_favorite_modal button#save_tag_report_favorite', function () {
        saveTagReportFavorite();
    });

    $(document).on('click', 'div#tag_report_wrapper a.tag_report_favorite_list_item', function () {
        let tagReportFavoriteId = $(this).attr('tag_report_favorite_id');
        getFormWithFavoriteSelected(tagReportFavoriteId);
    });

    $(document).on('click', 'div#tag_report_wrapper input[name="display_deactivated"]', function(){
        refreshList();
    });

    /*
     * Display or hide filter options
     */
    $(document).on('click', 'div#tag_favorites_list_wrapper span#filter_span_wrapper', function(){
        toggleListFilterOptions();
    });

    $(document).on('keyup', 'div#tag_report_wrapper div#tag_favorites_list_wrapper input#favorite_search_input', function (e) {
        let key = e.which;
        let searchInput = $('div#tag_favorites_list_wrapper input#favorite_search_input');
        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || $.trim(searchInput.val()) === '') {
            refreshList();
        }
    });

    $(document).on('click', 'div#tag_report_wrapper div#tag_favorites_list_wrapper button#favorite_search_button', function (e) {
        refreshList();
    });


    $(document).on('click', 'div#save_tag_report_favorite_modal button.change-status', function(){
        let currentStatus = $(this).attr('current_status');
        toggleTagReportFavoriteStatus(currentStatus)
    });


    function toggleListFilterOptions() {
        // Toggle the filters wrapper
        $('div#filter_options_wrapper').toggle();

        // Change class of the glyphicon (arrow right or down
        let arrow = $('span#filter_span_wrapper span.glyphicon');
        if ($(arrow).hasClass('glyphicon-chevron-right')) {
            // Switch to down arrow
            $(arrow).removeClass('glyphicon-chevron-right');
            $(arrow).addClass('glyphicon-chevron-down');
        } else {
            // Switch to down right
            $(arrow).removeClass('glyphicon-chevron-down');
            $(arrow).addClass('glyphicon-chevron-right');
        }
    }

    function onReportFetched(dataObj) {
        $('div#tag_report_content').html(dataObj.html);
    }

    function onError(errorText) {
        $('div#tag_report_content').html('<div class="alert alert-danger">' + errorText + "</div>");
    }

    function getTagReport() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let data = getFormData();

        $.ajax({
            type: 'GET',
            url: ajaxPathGetTagReport,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            onReportFetched(data);
        }).error(function (data) {
            onError($.parseJSON(data.responseText).errors);
        }).always(function () {
           ajaxLockActive = false;
        });
    }

    function createExcelFile() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let data = getFormData();

        $.ajax({
            type: 'GET',
            url: excelExportURL,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            onError($.parseJSON(data.responseText).errors);
        }).always(function () {
           ajaxLockActive = false;
        });
    }

    function getFormData() {
        return {
            date_from: $('input#date_from').val(),
            date_to: $('input#date_to').val(),
            product_group_tags: $('select#select_box_include_product_group_tags').chosen().val(),
            product_tags: $('select#select_box_include_product_tags').chosen().val(),
            excluded_product_group_tags: $('select#select_box_exclude_product_group_tags').chosen().val(),
            excluded_product_tags: $('select#select_box_exclude_product_tags').chosen().val()
        };
    }



    function saveTagReportFavorite() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        let tagReportFavoriteId = 0;
        let tagReportFavoriteIdElement = $('div#tag_report_form_wrapper input#tag_report_favorite_id');
        if (tagReportFavoriteIdElement.length) {
            tagReportFavoriteId = tagReportFavoriteIdElement.val() * 1;
        }

        let tagReportFavoriteName = $('input#tag_report_favorite_name').val();
        let productGroupTags = $('select#select_box_include_product_group_tags').chosen().val();
        let productTags = $('select#select_box_include_product_tags').chosen().val();
        let excludeProductGroupTags = $('select#select_box_exclude_product_group_tags').chosen().val();
        let excludeProductTags = $('select#select_box_exclude_product_tags').chosen().val();
        let tagReportPeriodSelected = $('select#tag_report_period').chosen().val();
        let tagReportEmail = $('input#tag_report_email').val();
        let tagReportEmailCopy = $('input#tag_report_email_copy').val();

        $.ajax({
            type: 'POST',
            url: ajaxPathSaveTagReportFavorite,
            data: {
                'tag_report_favorite_id' : tagReportFavoriteId,
                'tag_report_favorite_name' : tagReportFavoriteName,
                'product_group_tags' : productGroupTags,
                'product_tags' : productTags,
                'excluded_product_group_tags' : excludeProductGroupTags,
                'excluded_product_tags' : excludeProductTags,
                'tag_report_period' : tagReportPeriodSelected,
                'tag_report_email' : tagReportEmail,
                'tag_report_email_copy' : tagReportEmailCopy
            },
            dataType: 'json'
        }).success(function (data) {
            if (data.hasOwnProperty('tag_report_favorite_id') && data.tag_report_favorite_id !== '') {
                getFormWithFavoriteSelected(data.tag_report_favorite_id, true);
            } else {
                getFormWithFavoriteSelected(tagReportFavoriteId, true);
            }

            refreshList();
        }).error(function (data) {
            let errorMessage = $.parseJSON(data.responseText).errors;
            displaySaveErrorMessage(errorMessage);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function getFormWithFavoriteSelected(tagReportFavoriteId, includeSaveSuccessMessage) {
        if (!$.isNumeric(tagReportFavoriteId)) {
            return;
        }

        $.ajax({
            type: 'GET',
            url: ajaxPathGetForm + tagReportFavoriteId,
            dataType: 'json'
        }).success(function (data) {
            $('div#tag_report_form_wrapper').replaceWith(data.html);
            activateChosenPlugin();
            activateDatepicker();

            if (includeSaveSuccessMessage) {
                displaySaveSuccessMessage();

                // Old modal is interrupting page -> force close to reset z-index
                // @TODO: Find better way
                $('div#save_tag_report_favorite_modal').modal('show');
                $('div#save_tag_report_favorite_modal').modal('hide');
            }
        }).error(function () {
            let element = $('div#tag_report_wrapper');
            let errorMessage = 'Kunne ikke hente favoritt. Vennligst last siden på nytt og prøv igjen';

            displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function displaySaveSuccessMessage() {
        $('div#save_tag_report_favorite_modal').modal('hide');
        let element = $('div#tag_report_form_wrapper div#alert_container');
        let successMessage = '';

        displayAlertMessage('Favoritt lagret!', successMessage, 'success', element);
    }

    function displaySaveErrorMessage(errorMessage = '') {
        let element = $('div#save_tag_report_favorite_modal div.modal-body div.form-horizontal:first');
        if (errorMessage === '') {
            errorMessage = 'Kunne ikke lagre favoritt, vennligst prøv igjen';
        }

        displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
    }

    function activateChosenPlugin() {
        $("select.select_chosen_with_color_support").chosen({
            no_results_text: "Ingen tags funnet!",
            width: "100%",
        });
    }

    function refreshList() {

        let path = ajaxPathGetTagReportFavoriteListItems;
        if ($('div#tag_report_wrapper input[name="display_deactivated"]').is(':checked')) {
            path = ajaxPathGetTagReportFavoriteListItems + "?include_deactivated=1";
        }

        let searchString = $.trim($('div#tag_report_wrapper input#favorite_search_input').val());

        $.ajax({
            type: 'GET',
            url: path,
            data: {
                search_string: searchString
            },
            dataType: 'json',
        }).success(function (data) {
            $('div#tag_favorites_list_wrapper div.list-group').replaceWith(data.html);
        }).error(function (data) {
            let element = $('div#tag_report_wrapper');
            let errorMessage = 'Kunne ikke oppdatere listen over favoriserte tagfilter';

            displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /*
	 * Change status of tagReportFavorite
	 * Status = 1: active
	 * Status = 0: deactivated
	 */
    function toggleTagReportFavoriteStatus(currentStatus) {
        // User must confirm deactivation
        if (currentStatus === '1') {
            if (!confirm('Vil du deaktivere denne favoritten? Du kan når som helst reaktivere den igjen.')) {
                return;
            }
        }

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        // Set correct action, activate or deactivate
        let tagReportFavoriteId = $('div#tag_report_form_wrapper input#tag_report_favorite_id').val() * 1;
        let action = '';
        if (currentStatus === '1') {
            action = 'deactivate';
        } else {
            action = 'reactivate';
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'PUT',
            url: ajaxPathTagReport + '/favorite/' + tagReportFavoriteId + '/' + action
        }).success(function (data) {
            getFormWithFavoriteSelected(tagReportFavoriteId, true);

            // Update list
            refreshList();

            // Scroll window to the top
            window.scrollTo(0, 0);
        }).error(function () {
            displaySaveErrorMessage('Kunne ikke endre status på favoritt. Vennligst last siden på nytt og prøv igjen');
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function activateDatepicker() {
        $('div#tag_report_wrapper input.datepicker').datepicker({
            dateFormat: "dd/mm/yy"
        });
    }

});